import { RouterProvider as Provider } from 'react-router-dom';
import router from '@/router/router';

function RouterProvider() {
  return <Provider router={router} />;
}

export default RouterProvider;
